<!-- Modal header -->
<div class="modal-header sk-modal-header">
  <div class="sk-modal-title-group">
    <div class="sk-modal-icon"><i class="fa-solid fa-star"></i></div>
    <div>
      <div class="sk-modal-title" translate>Compétences</div>
      <div class="sk-modal-sub" *ngIf="section?.translation">{{ section.translation }}</div>
    </div>
  </div>
  <button type="button" class="sk-close-btn" (click)="close()">
    <i class="fa-solid fa-xmark"></i>
  </button>
</div>

<!-- Modal body (scrollable) -->
<div class="modal-body sk-modal-body">

  <!-- Loading -->
  <div *ngIf="loader" class="d-flex justify-content-center py-5">
    <app-spinner></app-spinner>
  </div>

  <div *ngIf="!loader">

    <!-- Stats summary -->
    <div class="sk-stats-row">
      <div class="sk-stat sk-stat-acquired">
        <span class="sk-stat-count">{{ skills.acquired.length }}</span>
        <span class="sk-stat-label" translate>Acquises</span>
      </div>
      <div class="sk-stat sk-stat-progress">
        <span class="sk-stat-count">{{ skills.inProgress.length }}</span>
        <span class="sk-stat-label" translate>En cours</span>
      </div>
      <div class="sk-stat sk-stat-todo">
        <span class="sk-stat-count">{{ skills.notAcquired.length }}</span>
        <span class="sk-stat-label" translate>À acquérir</span>
      </div>
    </div>

    <!-- Acquired -->
    <ng-container *ngIf="skills.acquired?.length">
      <div class="sk-group-label">
        <i class="fa-solid fa-circle-check"></i>
        <span translate>Acquises</span>
        <span class="sk-group-count">{{ skills.acquired.length }}</span>
      </div>
      <app-game-skill-item *ngFor="let skill of skills.acquired; trackBy: trackById" [skill]="skill" type="acquired"></app-game-skill-item>
    </ng-container>

    <!-- In progress -->
    <ng-container *ngIf="skills.inProgress?.length">
      <div class="sk-group-label sk-group-label-progress">
        <i class="fa-solid fa-circle-half-stroke"></i>
        <span translate>En cours</span>
        <span class="sk-group-count">{{ skills.inProgress.length }}</span>
      </div>
      <app-game-skill-item *ngFor="let skill of skills.inProgress; trackBy: trackById" [skill]="skill" type="in-progress"></app-game-skill-item>
    </ng-container>

    <!-- Not acquired -->
    <ng-container *ngIf="skills.notAcquired?.length">
      <div class="sk-group-label sk-group-label-todo">
        <i class="fa-regular fa-circle"></i>
        <span translate>À acquérir</span>
        <span class="sk-group-count">{{ skills.notAcquired.length }}</span>
      </div>
      <app-game-skill-item *ngFor="let skill of skills.notAcquired; trackBy: trackById" [skill]="skill" type="not-acquired"></app-game-skill-item>
    </ng-container>

  </div>

</div>
